(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g_password-footer"]) return;
  try {
    
    const pwdFooter = document.querySelector('[data-password-footer]');
    document.documentElement.style.setProperty('--password-footer-height', `${pwdFooter.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g_password-header"]) return;
  try {
    
    const pwdHeader = document.querySelector('[data-password-header]');
    document.documentElement.style.setProperty('--password-header-height', `${pwdHeader.offsetHeight}px`);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happibee-shopping-compass"] && !Shopify.designMode) return;
  try {
    
function initHappibeeCompass(root) {
  root.querySelectorAll('.hb-compass').forEach(compass => {
    if (compass.dataset.ready) return;
    compass.dataset.ready = 'true';
    const filters = compass.querySelector('.hb-compass__filters');
    const items = [...compass.querySelectorAll('[data-compass-group]')];
    const status = compass.querySelector('[data-compass-status]');
    filters.hidden = false;
    const update = group => {
      let count = 0;
      items.forEach(item => { item.hidden = group !== 'all' && item.dataset.compassGroup !== group; if (!item.hidden) count++; });
      filters.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.compassFilter === group)));
      status.textContent = status.dataset.template.replace('__COUNT__', String(count));
    };
    filters.addEventListener('click', event => { const button = event.target.closest('[data-compass-filter]'); if (button) update(button.dataset.compassFilter); });
    update('everyday');
  });
}
initHappibeeCompass(document);
document.addEventListener('shopify:section:load', event => initHappibeeCompass(event.target));

  } catch(e) { console.error(e); }
})();
})();
